export const contactsData = {
    email: 'alokshakay2601@gmail.com',
    phone: '+91 7078062885',
    address: 'Harsaon Shastri Nagar Ghaziabad',

    sheetAPI: 'https://sheetdb.io/api/v1/7esavcdkwip4e'
}